export default {
	required: v => !!v || 'This field is required',
	isNumber: v => !isNaN(v) || 'This field must be a number.',
	build: rules => {
		return rules.map(rule => this[rule]);
	}
}
